export class SubscriptionPackageEntitlement {
  subscriptionPackageId?: any;
  entitlementId?: any;
}
